var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "b9ebc457-a5fd-4d43-90cf-d1110b5b00d1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "575121cf-86a4-4668-bcd4-f35ad0da9037"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(67.5 0 0 67.5 540 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(128,128,128)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-8, -8)",
    d: "M 8 16 C 10.1217 16 12.1566 15.1571 13.6569 13.6569 C 15.1571 12.1566 16 10.1217 16 8 C 16 5.87827 15.1571 3.84344 13.6569 2.34315 C 12.1566 0.842855 10.1217 0 8 0 C 5.87827 0 3.84344 0.842855 2.34315 2.34315 C 0.842855 3.84344 0 5.87827 0 8 C 0 10.1217 0.842855 12.1566 2.34315 13.6569 C 3.84344 15.1571 5.87827 16 8 16 Z M 11.707 6.707 C 11.8892 6.5184 11.99 6.2658 11.9877 6.0036 C 11.9854 5.7414 11.8802 5.49059 11.6948 5.30518 C 11.5094 5.11977 11.2586 5.0146 10.9964 5.01233 C 10.7342 5.01005 10.4816 5.11084 10.293 5.293 L 7 8.586 L 5.707 7.293 C 5.5184 7.11084 5.2658 7.01005 5.0036 7.01233 C 4.7414 7.0146 4.49059 7.11977 4.30518 7.30518 C 4.11977 7.49059 4.0146 7.7414 4.01233 8.0036 C 4.01005 8.2658 4.11084 8.5184 4.293 8.707 L 6.293 10.707 C 6.48053 10.8945 6.73484 10.9998 7 10.9998 C 7.26516 10.9998 7.51947 10.8945 7.707 10.707 L 11.707 6.707 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8ac68c76ecd3ba65c3544382eafc4270.svg";
export { ForwardRef as ReactComponent };